import axios from 'axios'

export type LoginError = {
  message: string
}

export type LoginResponse = {
  expiresAt: string
  id: string
  userId: string
  updatedAt: string
  createdAt: string
}

export const loginUser = (email: string, password: string) =>
  axios.post<LoginResponse | LoginError>('/sessions', { email, password })

export const logoutUser = (sessionId: string) => axios.delete(`/sessions/${sessionId}`)
